<template>
<load-content :loading="!isReady">
  <div class="card">
    <div id="project-tags-filters" class="d-flex">
      <div class="div-categories-tag col-md-4">
        <template v-if="selectedCategory">
          <h5>{{$t("tag.form.filters.tag_by_category")}}</h5>
          <input-select
          id="categories"
          :selectedValue="selectedOrganizationCategoryId || selectedCategoryId"
          :options="categoryOptions"
          open-direction="bottom"
          :searchable="true"
          :onChange="onChangeSelectCategories"
          :preselectFirst="true"
          :allowEmpty="false"
          :disabled="displayTableBySearch"
          :onSearchChange="handleCategorySearchChange"
          :loading="this.isCategoriesBusy"
          />
        </template>
      </div>

      <div v-if="selectedParentTagId && isUseOrgWithCategory" class="div-categories-tag col-md-4">
        <template>
          <h5>{{$t("tag.form.filters.tag_by_sub_category")}}</h5>
          <input-select
            id="child-categories"
            :key="counter"
            :selectedValue="selectedParentTagId"
            :options="organizationsCategoryOptions"
            :onChange="onChildCategoryChange"
            :allowEmpty="false"
            :searchable="true"
            :preselectFirst="true"
            :disabled="this.isCategoriesBusy"
            open-direction="bottom"
            option-value="id"
            option-label="name"
          />
        </template>
      </div>

      <div class="col-md-4">
        <DatatableSearch
          name="search-articles"
          :data="categoryTypes"
          :data-headline="false"
          :data-outlet="false"
          :simple-select="true"
          :submittedSearchParams="submittedSearchParams"
          :onSearchSubmit="onSearchNameSubmit"
          :isBusy="false"
          :filters="filters"
        />
      </div>

      <div class="col-md-4">
        <div class="datatable-search-wrapper">
          <date-range-picker
            name="from"
            :value="range"
            inputType="date"
            valueType="YYYY-MM-DD"
            :range="true"
            format="MMM DD YYYY"
            :clearable="true"
            range-separator=" - "
            @onInputChange="onDateInputChanged"
            calendarButtonIcon="fas fa-calendar-alt"
          >
          </date-range-picker>
        </div>
      </div>

      <div class="pn-tags-actions">
        <div v-if="selectedParentTag && selectedParentTag.allow_add_children === true" class="mr-4">
          <a class="text-danger" v-tooltip="$t('tag.delete_tags_with_no_associated_articles')" @click="deleteTagsWithNoAssociatedArticles">
            <i class="fas fa-trash"></i>
          </a>
      </div>
        <a :href="`/analysis/projects/${project.project_id}/tags/usage-report`">{{$t("tag.usage_report")}}</a>
      </div>
    </div>
    <load-content :loading="initialLoading">
      <div v-if="showDataList || (usedTableSearch && showDateByFilters)">
        <datatable
          ref="tagstable"
          v-bind:data="currentDataTable"
          :key="`tableByCategory${counter}`"
          :updatingRow="updatingRowId"
        />
        <div class="loading-next-page" v-if="loadingNextPage"><loader /></div>
        <div 
          v-if="this.tagsPagination && this.tagsPagination.totalCount" 
          class="border-secondary bg-white position-fixed bottom-0 rounded border border-1 d-inline-block px-3 my-3 border-info shadow">
          {{ this.tagsPagination.currentPage + ' / ' + this.tagsPagination.totalPages }} {{$t("tag.form.filters.pages")}}
        </div>
        <side-panel v-if="showDeleteTag == true" :onClose="closeDeletePanel">
          <template>
            <load-content :loading="initialLoading">
              <confirm-delete
                  :label="deleteTagObj.name"
                  :onDelete="() => deleteTag(deleteTagObj)"
              />
            </load-content>
          </template>
        </side-panel>
      </div>
      <div v-else-if="currentCategory && isSourceCategory">
        <datatable
          ref="tagstable"
          :data="dataTableTagSource"
          :key="counter"
          :updatingRow="updatingRowId"
        />
        <div class="loading-next-page" v-if="loadingNextPage"><loader /></div>
        <side-panel v-if="showDeleteTag === true" :onClose="closeDeletePanel">
          <template>
            <load-content :loading="initialLoading">
              <confirm-delete
                  :label="deleteTagObj.first_name + (deleteTagObj.last_name ? ' ' + deleteTagObj.last_name : '')"
                  :title="'messages.confirm_delete.title_remove'"
                  :message="'messages.confirm_delete.message_remove'"
                  :deleteButtonLabel="'remove'"
                  :onDelete="() => deleteSource(deleteTagObj)"
              />
            </load-content>
          </template>
        </side-panel>
      </div>
    </load-content>
  </div>

  <div v-if="selectedRows.length > 0" class="datatable-bulk-actions">
    <span>{{selectedLabel}}</span>
    <div class="actions d-flex justify-content-evenly w-50 cursor-pointer">
      <div v-if="(isUseOrgWithCategory ? project.enable_auto_coder && selectedRows.length > 1 : selectedRows.length > 1)" 
        class="action btn-primary" @click="onBulk('merge')">{{$t("tag.merge")}}</div>
      <div class="action btn-primary" @click="onBulk('edit')">{{$t("tag.edit")}}</div>
      <template v-if="currentCategory && currentCategory.category_type_id !== CATEGORY_TYPES.ORGANIZATION">
        <div class="action btn-primary" @click="onBulk('delete')">{{$t("tag.delete")}}</div>
      </template>
    </div>
  </div>

  <side-panel v-if="bulkEditOpen" :onClose="closeSidePanel">
    <template>
      <load-content :loading="isBusy">
        <div class="selected-label">
          <h3>{{$t("tag.form.bulk.edit_title")}}</h3>
          <p>{{$t("tag.form.bulk.edit_confirm", {selectedLabel: selectedLabel})}}</p>
        </div>
        <div class="form form--sidepanel">
        <div class="form-group">
          <label for="tag-id">{{$t("tag.form.bulk.edit_tag_approve")}}</label>
          <input-select
            name="tag-id"
            :options="options"
            :onChange="(value) => currentCategory.category_type_id !== CATEGORY_TYPES.SOURCE ? onBulkUpdate('approved', value) : onBulkSourceUpdate('approved', value)"
            :selectedValue="options"
          />
        </div>
        </div>
      </load-content>
    </template>
  </side-panel>

    <side-panel v-if="bulkMergeOpen" :onClose="closeSidePanel">
      <template>
        <load-content :loading="isBusy">
          <div class="selected-label">
            <h3>{{$t("tag.form.bulk.merge_title", {selectedLabel: selectedLabel})}}</h3>
            <p v-if="duplicated">{{$t("tag.form.bulk.merge_confirm_duplicated")}}</p>
            <p>{{$t("tag.form.bulk.merge_confirm")}}</p>
          </div>
          <div class="form form--sidepanel">
          <div class="form-group">
            <label for="tag-id">{{$t("tag.form.bulk.merge_tag_label")}}</label>
            <input-select
              id="categories"
              v-model="mergeId"
              :options="selectedRowsOptions"
              open-direction="bottom"
              :searchable="true"
          />
          </div>
          <password-prompt ref="prompt" @isValid="handlePasswordValid" authAction="merge_tags" />
           <div class="form__group field">
                <input type="button" :disabled="!isPasswordValid || validatingPassword" value="Save" class="btn btn-carma" @click="onMergeTags"/>
            </div>
          </div>
        </load-content>
      </template>
  </side-panel>

  <side-panel v-if="bulkDeleteOpen" :onClose="closeSidePanel">
    <template>
      <load-content :loading="isBusy">
        <confirm-delete
          :label="selectedLabel"
          :bulk="true"
          :onDelete="onBulkDelete"
        />
      </load-content>
    </template>
  </side-panel>

  <side-panel v-if="showDeleteTagsWithNoArticlesConfirm" :onClose="closeSidePanel">
    <template>
      <load-content :loading="isBusy">
        <confirm-delete
          :label="$t('tag.delete_tags_with_no_associated_articles')"
          :title="'messages.confirm_delete.title'"
          :message="'messages.confirm_delete.tags_with_no_associated_articles'"
          :onDelete="confirmDeleteTagsWithNoAssociatedArticles"
        />
      </load-content>
    </template>
  </side-panel>

  <side-panel v-if="showEditTagSource" :onClose="closeSidePanel">
    <form-renderer
      id="edit-source-form"
      title="tag.form.edit_source.title"
      :key="counter"
      formGroupClass="form-group-full"
      :fields="['first_name', 'middle_name', 'last_name', 'title', 'job_title', 'display_name', 'affiliation_id']"
      :fields-additions="fieldsAdditions"
      :model="sourceEdit"
      @onSave="onSendSource"
    />
  </side-panel>

</load-content>
</template>

<script>
import Vue from 'vue';
import Datatable from '../datatable';
import _ from 'lodash';
import InputSelect from '../form-components/input-select'
import LoadContent from '../load-content';
import Loader from "../../components/loader";
import { FIELD_TYPE, CATEGORY_TYPES, VALIDATIONS } from "../../config/const";
import { propsForMixin } from "../../helpers/application";
import CodingHeadline from '../coding-headline';
import { mapState, mapActions, mapGetters } from 'vuex';
import SidePanel from "../../components/side-panel";
import ConfirmDelete from "../../components/confirm-delete";
import InputToggle from '../form-components/input-toggle';
import FormRenderer from "../form-renderer";
import DatatableSearch from '../../components/datatable-search';
import PasswordPrompt from '../password-prompt';
import { displayDate } from "../../helpers/date";
import DateRangePicker from '../../components/date-picker-2';
import moment from 'moment';

export default {
  name: 'TagsList',
  components: {
    datatable: Datatable,
    LoadContent,
    Loader,
    SidePanel,
    ConfirmDelete,
    InputSelect,
    FormRenderer,
    DatatableSearch,
    PasswordPrompt,
    DateRangePicker
  },
  async created(){
    const projectUid = this.$route.params.project_uid;
    let routeCategoryId = this.$route.query.category_id;
    this.selectedOrganizationCategoryId = this.$route.query.organization_category_id
    this.selectedParentTagId = this.$route.query.parent_tag_id
    this.filters.fromDate = this.$route.query.fromDate || undefined;
    this.filters.toDate = this.$route.query.toDate || undefined;
    
    // call project setup before the separated categories call, 
    // not to be overwritten for non mmi project
    await this.getprojectSetup({ projectUid });
    this.fetchCategories(projectUid, routeCategoryId, this.selectedOrganizationCategoryId, this.selectedParentTagId, this.pagination)
    this.CATEGORY_TYPES = CATEGORY_TYPES
    this.scroll()
  },
  computed: {
    ...mapState({
      isBusy: state => state.projectSetup.projectSetup.isBusy,
      isTagsBusy: state => state.projectSetup.projectSetup.isTagsBusy,
      isUpdateTagsBusy: state => state.projectSetup.projectSetup.isUpdateTagsBusy,
      isCategoriesBusy: state => state.projectSetup.projectSetup.isCategoriesBusy,
      setupIsReady: state => state.projectSetup.projectSetup.isReady,
      setup: state => state.projectSetup.projectSetup.data,
      sources: state => state.projectSetup.projectSetup.data ? state.projectSetup.projectSetup.data.sources : [],
      tags: state => state.projectSetup.projectSetup.data ? state.projectSetup.projectSetup.data.tags : [],
      tagsPagination: state => state.projectSetup.projectSetup.data ? state.projectSetup.projectSetup.data.tagsPagination : [],
      affiliations: state => state.projectSetup.projectSetup.data.affiliations || [],
      project: state => state.projects.project.data
    }),

    initialLoading() {
      return this.isBusy || this.isChildCategoryLoading;
    },

    loadingNextPage() {
      return this.isTagsBusy || !this.setupIsReady;
    },

    usedTableSearch() {
      let isUsed = false;

      Object.keys(this.filters).forEach(item => {
        if (this.filters[item]?.length) isUsed = true;
      });

      return isUsed;
    },
    isSourceCategory() {
      return this.currentCategory && this.currentCategory.category_type_id === CATEGORY_TYPES.SOURCE;
    },
    range() {
      return [
        this.filters.fromDate ? moment.utc(this.filters.fromDate).format('YYYY-MM-DD') : null,
        this.filters.toDate ? moment.utc(this.filters.toDate).format('YYYY-MM-DD') : null
      ];
    },
    isUseOrgWithCategory() { return this.setup?.general?.organizations_with_category },
    organizationCategoryId() { return this.setup?.general?.organizations_category_id },
    isOrganization() {
      return this.currentCategory.category_type_id === CATEGORY_TYPES.ORGANIZATION
    },
    showDataList() {
      return (
        this.currentCategory &&
        (
          this.currentCategory.category_type_id === CATEGORY_TYPES.MEDIA_TAG ||
          (
            this.currentCategory.category_type_id >=
            CATEGORY_TYPES.ARTICLE_FEATURE &&
            this.currentCategory.category_type_id <= CATEGORY_TYPES.ORGANIZATION
          )
        )
      );  
    },
    selectedCategory() { 
      let initialCategory = this.categories;
      let category = this.categories.find(category => category.id === (this.selectedOrganizationCategoryId || this.selectedCategoryId));
      if(!category) category = initialCategory;
      return category;
    },
    selectedLabel() {
      return `${this.selectedRows.length} ${
        this.selectedRows.length == 1 ? "tag" : "tags"
      } selected`;
    },
    selectedRowsOptions() {
      return this.selectedRows.map(option => ({
        value: option.id,
        label: this.getSourceOptionLabel(option),
      }));
    },
    categories () {
      let categories = [];

      const { setup } = this;
      if (_.has(setup, 'categories.data.data')) {
        categories = setup.categories.data.data.filter(c => c.category_type_id !== CATEGORY_TYPES.GROUPING);
      }

      return categories;
    },
    categoryOptions(){
      return this.categories.length > 0 ? this.categories.map(option => ({value: option.id, label: option.name})) : [];
    },
    currentCategory() { 
      return this.categories.find(category => category.id === (this.selectedOrganizationCategoryId || this.selectedCategoryId))
    },
    organizationId() {
      return this.categories.find(ct => ct.name.toLocaleLowerCase() === 'organizations')?.id;
    },
    isMmiProject() { return this.setup?.general?.organizations_with_category && this.selectedCategory?.name?.toLocaleLowerCase() === this.weightOfCoverageName; },
    currentCategoryTags() { 
      return this.tags ? this.tags.map((tag) => ({
        ...tag, 
        name: tag.is_private ? `${this.$i18n.t('tag.labels.privateTag')} : ${tag.name}` : tag.name
      })) : [];
    },
    sourceEdit() { 
      return this.currentCategoryTags && this.currentCategoryTags.find(tag => tag.id === this.currentCategoryTagId) 
    },
    columns() {
      const category = _.cloneDeep(this.currentCategory);

      return [
          {
            key: 'id',
            label: `${this.$i18n.t('tag.list.tag_id')}`,
          },
          {
            key: 'name',
            label: `${this.$i18n.t('tag.list.tag_name')}`,
            orderable: !this.isMmiProject,
            input: {
              name: "name",
              type: FIELD_TYPE.INPUT,
              styleNames: {
                color: "#ec9148",
                border: "none",
                outline: "0px",
                fontSize: '14px',
              },
              onBlur: (value, key, row) => {
                this.updateInput(value, key, row);
              },
              readOnly: this.isUpdateTagsBusy || category.scoring_default === true || this.isMmiProject
            },
            render: this.isMmiProject ? ({ name, value } = {}) => {
              return (
                <span v-tooltip={{ content: value }}>
                  {name}
                </span>
              );
            } : undefined
          },
          {
            key: 'created_by',
            label: `${this.$i18n.t('tag.list.tag_created_by')}`,
            orderable: !this.isMmiProject
          },
          {
            key: 'created_at',
            label: `${this.$i18n.t('tag.list.tag_created_at')}`,
            orderable: true,
            render: (row) => {
              return row.created_at ?  displayDate(row.created_at, undefined, true)  : ''
            }
          },
          {
            key: 'article_count',
            label: `${this.$i18n.t('tag.list.associated_articles')}`,
            orderable: !this.isMmiProject,
            render: ({article_count, id} = {}) => {
              return (article_count > 0 ?  <router-link style="color:#ec9148;" to={category.category_type_id === CATEGORY_TYPES.ORGANIZATION ? `/analysis/projects/${this.$route.params.project_uid}/organizations/${id}/articles?page=1` : `/analysis/projects/${this.$route.params.project_uid}/tags/${id}/articles?page=1`}>{article_count}</router-link> : <span>{article_count || 0}</span>)
            }
          },
          {
            key: 'approved',
            label: `${this.$i18n.t('tag.list.tag_approved')}`,
            style: { 'min-width': '200px' },
            input: {
              name: "approved",
              type: FIELD_TYPE.TOGGLE,
              onChange: (value, key, row) => {
                this.updateInput(value, key, row);
              },
              disabled: this.isUpdateTagsBusy || (typeof category.scoring_default === 'boolean' && category.scoring_default === true) || this.isMmiProject
            }
          },
          {
            key: 'approved_updated_at',
            label: `${this.$i18n.t('tag.list.last_updated_at')}`,
            orderable: !this.isMmiProject,
            render: row => { 
              if (row.approved_updated_at)
                return displayDate(new Date(row.approved_updated_at))
              
              return '-';
            }
          },
        ];
    },
    
    datatable () {
      const self = this;
      const category = _.cloneDeep(this.currentCategory); //categories.find(c => c.id === this.currentCategory.id);

      return {
        custom_components: {
            'coding-headline': CodingHeadline,
            'input-toggle': InputToggle,
          },
        resizable: true,
        columns: this.columns,
        body: this.currentCategoryTags,
        removeRow: {
          enabled: (typeof category.scoring_default === 'boolean' && !category.scoring_default === true) && !this.isMmiProject,
          onClick: function(row){
            self.openDeletePanel(row);
          }
        },
        order: {
          column: self.pagination.order,
          direction: self.pagination.sort,
          onChange: function(column, direction) {
            self.onSortTable({ order: column, sort: direction });
          }
        },
        bulkActions: {
            enabled: (typeof category.scoring_default === 'boolean' && category.scoring_default === true && category.category_type_id === CATEGORY_TYPES.ORGANIZATION ? true : typeof category.scoring_default === 'boolean' && !category.scoring_default === true) && !this.isMmiProject,
            onSelect: function(rows) {
              self.selectedRows = rows;
            }.bind(this)
          },
      }
    },

    columnsTableSearch() {
      const category = _.cloneDeep(this.currentCategory);

      return [
        {
          key: 'id',
          label: `${this.$i18n.t('tag.list.tag_id')}`,
        },
        {
          key: 'category_type_name',
          label: `${this.$i18n.t('tag.list.tag_category_type')}`,
        },
        {
          key: 'name',
          label: `${this.$i18n.t('tag.list.tag_name')}`,
          orderable: true,
          input: {
            name: "name",
            type: FIELD_TYPE.INPUT,
            styleNames: {
              color: "#ec9148",
              border: "none",
              outline: "0px",
              fontSize: '14px',
            },
            onBlur: (value, key, row) => {
              this.updateInput(value, key, row);
            },
            readOnly: category.scoring_default === true
          }
        },
        {
          key: 'created_by',
          label: `${this.$i18n.t('tag.list.tag_created_by')}`,
          orderable: true
        },
        {
          key: 'created_at',
          label: `${this.$i18n.t('tag.list.tag_created_at')}`,
          orderable: true,
          render: (row) => {
            return row.created_at ?  displayDate(row.created_at, undefined, true)  : ''
          }
        },
        {
            key: 'article_count',
            label: `${this.$i18n.t('tag.list.associated_articles')}`,
            orderable: true,
            render: ({article_count, id} = {}) => {
              return (article_count > 0 
                ?  <router-link style="color:#ec9148;" to={category.category_type_id === CATEGORY_TYPES.ORGANIZATION ? `/analysis/projects/${this.$route.params.project_uid}/organizations/${id}/articles?page=1` 
                : `/analysis/projects/${this.$route.params.project_uid}/tags/${id}/articles?page=1`}>{article_count}</router-link> : <span>{article_count}</span>
              )
            }
        },
        {
          key: 'approved',
          label: `${this.$i18n.t('tag.list.tag_approved')}`,
          style: { 'min-width': '200px' },
          input: {
            name: "approved",
            type: FIELD_TYPE.TOGGLE,
            onChange: (value, key, row) => {
              this.updateInput(value, key, row);
            },
            disabled: true
          }
        },
        {
          key: 'approved_updated_at',
          label: `${this.$i18n.t('tag.list.last_updated_at')}`,
          orderable: true,
          render: row => { 
            if (row.approved_updated_at)
              return displayDate(new Date(row.approved_updated_at))
            
            return '-';
          }
        },
      ];
    },

    datatableBySearch () {
      const self = this;
      return {
        custom_components: {
            'coding-headline': CodingHeadline,
            'input-toggle': InputToggle,
          },
        resizable: true,
        columns: this.columnsTableSearch,
        body: this.tags,
        removeRow: {
          enabled: true,
          onClick: function(row){
            self.openDeletePanel(row);
          }
        },
        order: {
          column: self.pagination.order,
          direction: self.pagination.sort,
          onChange: function(column, direction) {
            self.onSortTable({ order: column, sort: direction });
          }
        },
        bulkActions: {
            enabled: true,
            onSelect: function(rows) {
              self.selectedRows = rows;
            }.bind(this)
          },
      }
    },

    dataTableTagSource () {
      const self = this;
      const category = this.currentCategory

      return {
        columns: [
          {
            key: "first_name",
            label: `${this.$i18n.t('tag.list.first_name')}`,
            orderable: true,
            input: {
              name: "first_name",
              type: FIELD_TYPE.INPUT,
              styleNames: { color: "#ec9148", border: "none" },
              classNames: "input-name",
              placeholder: `${this.$i18n.t('tag.list.first_name')}`,
              onBlur: function(value, key, row) {
                self.updateTagSource(value, key, row);
              }
            }
          },
          {
            key: "last_name",
            label: `${this.$i18n.t('tag.list.last_name')}`,
            orderable: true,
            input: {
              name: "last_name",
              type: FIELD_TYPE.INPUT,
              styleNames: { color: "#ec9148", border: "none" },
              classNames: "input-name",
              placeholder: `${this.$i18n.t('tag.list.last_name')}`,
              onBlur: function(value, key, row) {
                self.updateTagSource(value, key, row);
              }
            }
          },
          {
            key: 'article_count',
            label: `${this.$i18n.t('tag.list.associated_articles')}`,
            orderable: true,
            render: ({article_count, id} = {}) => {
              return (article_count > 0 ? <router-link style="color:#ec9148;" to={`/analysis/projects/${this.$route.params.project_uid}/sources/${id}/articles?page=1`}>{article_count}</router-link> : <span>{article_count}</span>)
            }
          },
          {
            key: 'approved',
            label: `${this.$i18n.t('tag.list.source_approved')}`,
            style: { 'min-width': '200px' },
            //orderable: true,
            input: {
              name: "approved",
              type: FIELD_TYPE.TOGGLE,
              onChange: function(value, key, row) {
                self.updateTagSource(value, key, row);
              }
            },
          },
          {
            Key: "",
            label: "",
            input: {
              name: "name",
              type: FIELD_TYPE.BUTTON,
              label_button: "...",
              onClick: function(key, row) {
                self.openSidePanel(row);
              }
            }
          }
        ],
        body: this.currentCategoryTags,
        resizable: true,
        removeRow: {
          enabled: typeof category.scoring_default === 'boolean' && !category.scoring_default === true,
          onClick: function(row){
            self.openDeletePanel(row);
          }
        },
        order: {
          column: self.pagination.order,
          direction: self.pagination.sort,
          onChange: function(column, direction) {
            self.onSortTable({ order: column, sort: direction });
          }
        },
        bulkActions: {
            enabled: true,
            onSelect: function(rows) {
              self.selectedRows = rows;
            }.bind(this)
          },
      }
    },

    currentDataTable() {
      if (this.showDateByFilters) {
        return this.datatableBySearch;
      }
      if (this.isSourceCategory){
        return this.dataTableTagSource;
      }
      return this.datatable;
    },

    fieldsAdditions() {
      return {
        title: {
          type: FIELD_TYPE.SELECT,
          translatePlaceholder: 'sources.select_title',
          style: 'order: 1;',
          customClass: 'mr10',
          validate: [VALIDATIONS.REQUIRED]
        },
        job_title: {
          style: 'flex-basis: 100%; order: 2;'
        },
        first_name: {
          style: 'flex-grow: 3; order: 3;'
        },
        middle_name: {
          style: 'flex-basis: 100%; order: 4;'
        },
        last_name: {
          style: 'flex-basis: 100%; order: 5;'
        },
        display_name: {
          style: 'flex-basis: 100%; order: 6;'
        },
        affiliation_id: {
          options: this.affiliations,
          optionValue: 'id',
          optionLabel: 'name',
          searchable: true,
          optionsLimit: 100,
          dropdownDirection: 'top',
          placeholder: this.$i18n.t('sources.affiliation.select'),
          hideSelected: false,
          style: 'flex-basis: 100%; flex-grow: 0; order: 7;',
          customClass: 'mr10',
          customLabel: this.displayLabel,
          trackBy: 'id',
          taggable: true,
          tagPlaceholder: "Press enter to create affiliation",
          validate: [VALIDATIONS.REQUIRED]
        },
      }
    },
    selectedParentTag() {
      if (!this.selectedParentTagId || !this.organizationsCategoryOptions.length) {
        return null;
      }
      return this.organizationsCategoryOptions.find(tag => tag.id === this.selectedParentTagId);
    },
  },
  methods: {
    ...mapActions({
       updateSetupTag: "projectSetup/updateTag",
       getTags: "tags/getTags",
       updateTag: "tags/updateTag",
       clearTags: "tags/clearTags",
       removeTag: "projectSetup/deleteTag",
       updateBulkTagsByProject: "projectSetup/updateBulkTagsByProject",
       mergeTags: "projectSetup/mergeTags",
       getCategories: "projectSetup/getCategories",
       getSources: "projectSetup/getSources",
       updateSource: "projectSetup/updateCategorySource",
       removeSource: "projectSetup/removeCategorySource",
       updateCategoryGrouping: "projectSetup/updateCategoryGrouping",
       getSourcesAffiliations: "projectSetup/getSourcesAffiliations",
       updateBulkSourceByProject: "projectSetup/updateBulkSourceByProject",
       getCategoryTags: "projectSetup/getCategoryTags",
       getCategoryTagsSearch: "projectSetup/getCategoryTagsSearch",
       getCategorySources: "projectSetup/getCategorySources",
       deleteBulkTags:"projectSetup/deleteBulkTags",
       deleteBulkSources: "projectSetup/deleteBulkSources",
       getprojectSetup: "projectSetup/getprojectSetup",
       deleteTagsWithNoArticles: "projectSetup/deleteTagsWithNoAssociatedArticles",
    }),
    fetchCategories(projectUid, routeCategoryId, organizationCategoryId, parentTagId, pagination, search){
      this.getCategories({ projectUid, pagination, search})
      .then(async () => {
        const defaultCategoryId = this.categories.length && this.categories[0].id
        if(routeCategoryId) {
          const existingRouteCategory = this.categories.find(cat => cat.id === parseInt(routeCategoryId))
          if(!existingRouteCategory) {
            this.$router.push({query: {}})
            routeCategoryId = null
          }
        }
        this.selectedCategoryId = parseInt(routeCategoryId) || defaultCategoryId;
        this.selectedOrganizationCategoryId = parseInt(organizationCategoryId) || '';
        this.selectedParentTagId = parseInt(parentTagId) || '';
        if(!this.organizationsCategoryOptions?.length && this.isUseOrgWithCategory && this.selectedOrganizationCategoryId === parseInt(organizationCategoryId)){
          await this.loadCategoryTagsOrSources(true);
        }
        this.loadCategoryTagsOrSources();
      }); 
    },
    clearFilters() {
      this.showDateByFilters = false;
      this.displayTableBySearch = false;
      // Preserve date filters when clearing other filters
      const fromDate = this.filters.fromDate;
      const toDate = this.filters.toDate;
      Object.keys(this.filters).forEach(key => {
        this.filters[key] = [];
      });
      // Restore date filters
      this.filters.fromDate = fromDate;
      this.filters.toDate = toDate;
      this.search = null;
      this.counter++;
    },
    async loadCategoryTagsOrSources(isOrganizationSubCategories){
      let datatable = this.currentDataTable
      if (datatable !== null) {
        const params = { 
          projectUid: this.projectUid, 
          categoryId: this.organizationsCategoryOptions.length ? this.selectedOrganizationCategoryId : this.selectedCategoryId || this.currentCategory.id, 
          pagination: { ...this.pagination, isMMI: this.isMmiProject},
          filters: {
            search: this.search, 
            organization_category_id: this.selectedOrganizationCategoryId, 
            parent_tag_id: isOrganizationSubCategories ? undefined : this.selectedParentTagId,
            fromDate: this.filters.fromDate ? moment.utc(this.filters.fromDate).format('YYYY-MM-DD') : undefined,
            toDate: this.filters.toDate ? moment.utc(this.filters.toDate).format('YYYY-MM-DD') : undefined,
            dateType: (this.filters.fromDate || this.filters.toDate) && !isOrganizationSubCategories ? 'tags_created_at' : undefined
          }
        };
        if (this.showDateByFilters) {
          await this.getCategoryTagsSearch(params);
        }
        else if (this.isSourceCategory){
          await this.getCategorySources(params);
        }else{
          await this.getCategoryTags(params);
        }
      }
    },
    getNextPage(){
      if (this.tagsPagination.currentPage < this.tagsPagination.totalPages){
        this.pagination.page ++;
      }
        
    },
    resetPagination(){
      this.pagination.page = 1;
    },
    onSearchNameSubmit(params) {
      if (!params || !params.length) return this.clearFilters();
      this.submittedSearchParams = params;
      // Handle different search types
      this.search = params.map(item => {
        // If it's a name/search type (for organization search)
        if (item.type === 'search' || item.type === 'name') {
          return {
            search_type: 'name',
            search_value: encodeURIComponent(item.value),
          };
        }
        // Handle other category types
        return {
          category_type_id: CATEGORY_TYPES[item.type.toUpperCase()],
          name: item.value,
        };
      });
      this.resetPagination();
    },
    onChangeSelectCategories: function (value) {
      this.clearFilters();
      let query = {}
      if(this.organizationId === value && this.isUseOrgWithCategory) {
        this.selectedOrganizationCategoryId = value;
        query = { organization_category_id: value }
        value = this.organizationCategoryId;
      } else {
        this.selectedOrganizationCategoryId = null;
        this.selectedParentTagId = null;
        this.organizationsCategoryOptions = [];
      }
      this.selectedCategoryId = parseInt(value)
      this.displayTableBySearch = false;
      query = { ...query, category_id: this.selectedCategoryId }
      query.fromDate = this.filters.fromDate || undefined;
      query.toDate = this.filters.toDate || undefined;
      query.dateType = (this.filters.fromDate || this.filters.toDate) ? 'tags_created_at' : undefined;
      
      this.$router.push({ query: query })
      this.resetPagination();
      this.loadCategoryTagsOrSources(true);
    },
    onChildCategoryChange(value){
      this.clearFilters();
      this.displayTableBySearch = false;
      let query = {query: { ...this.$route.query, parent_tag_id: value}}
      this.selectedParentTagId = value;
      this.$router.push(query)
      this.resetPagination();
      this.loadCategoryTagsOrSources();
    },
    handleCategorySearchChange: function (search) {
      const projectUid = this.$route.params.project_uid;
      const routeCategoryId = this.$route.query.category_id;
      const organizationCategoryId = this.$route.query.organization_category_id
      const parentTagId = this.$route.query.parent_tag_id
      this.fetchCategories(projectUid, routeCategoryId, organizationCategoryId, parentTagId, this.pagination, search)
    },
    onChangeMerge(id) {
      this.idOnChange = id;
    },
    getSourceOptionLabel(tag) {
      const name = tag.name || `${tag.first_name} ${tag.last_name}`;
      const countInfo = this.$tc("articles.count", tag.article_count, {
        count: tag.article_count,
      });

      return `${this.$i18n.t('tag.labels.tagName')} ${name} | ${this.$i18n.t('tag.labels.tagId')} ${tag.id}`;
    },
    async onMergeTags() {
      try {
        this.validatingPassword = true;
        await this.$refs.prompt.validate();
        this.mergeTags({
          projectUid: this.projectUid,
          tagId: this.mergeId,
          selectedTags: this.selectedRows,
          categoryIsSource: this.isSourceCategory,
          isOrganization: this.isOrganization,
          parentTagId: this.selectedParentTagId,
          pagination: this.pagination})
          this.selectedRows = [];
          this.duplicated = false;
          this.bulkEditOpen = false;
          this.closeSidePanel();
        } catch (error) {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: this.$t("messages.confirm_delete.password_confirm_error")
        })
      } finally { this.validatingPassword = false; }
    },
    async updateInput(value, key, row) {
      if((typeof value !== 'boolean' && !value) || !key || row?.[key] === value || this.isMmiProject) return;

      this.updatingRowId = row.id;

      let newValue = {
        ...row,
        [key]: value,
        parent_tag_id: this.selectedParentTagId
      }
      const projectUid = this.projectUid;
      await this.updateSetupTag({ projectUid, row: newValue });
      await this.updateTag({ tag: newValue });
      this.updatingRowId = null;
    },
    deleteTag(){
      const {projectUid, removeTag, closeDeletePanel, deleteTagObj: row} = this
      removeTag({projectUid, row}).then(() => {
        // this.resetPagination();
        // this.loadCategoryTagsOrSources();
        closeDeletePanel();
      });
    },
    deleteSource(row){
      const {projectUid, removeSource, closeDeletePanel} = this;
      removeSource({projectUid, sourceId: row.id}).then(()=> {
        this.resetPagination();
        this.loadCategoryTagsOrSources();
        closeDeletePanel();
      });
    },
    deleteTagsWithNoAssociatedArticles() {
      const { selectedParentTagId, currentCategory } = this;
      
      if (!selectedParentTagId || !currentCategory) {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: this.$t("messages.request.error")
        });
        return;
      }

      // Open confirmation modal
      this.showDeleteTagsWithNoArticlesConfirm = true;
    },
    confirmDeleteTagsWithNoAssociatedArticles() {
      const { projectUid, selectedParentTagId, currentCategory } = this;

      const categoryId = this.organizationsCategoryOptions.length 
        ? this.selectedOrganizationCategoryId 
        : this.selectedCategoryId || currentCategory.id;

      this.closeSidePanel();
      this.deleteTagsWithNoArticles({
        projectUid,
        categoryId,
        parentTagId: selectedParentTagId
      }).then(() => {
        this.resetPagination();
        this.loadCategoryTagsOrSources();
      });
    },
    updateTagSource(value, key, row) {
      const source = {
        ...row,
        [key]: value
      };
      const { projectUid } = this;
      this.updateSource({ projectUid, source });
    },
    updateGroupingRow(value, key, row) {
      let newRow = row;
      newRow[key] = value;

      const projectUid = this.projectUid;
      newRow = Object.assign({}, newRow);
      this.updateCategoryGrouping({ projectUid, row: newRow });
    },
    onBulkDelete: function(){
      const {projectUid, currentCategory, selectedRows: bulkTags, closeSidePanel} = this;
      if (this.isSourceCategory) {
        const {deleteBulkSources} = this;
        deleteBulkSources({projectUid, bulkTags}).then(r => {
          closeSidePanel();
          this.selectedRows = [];
        });
      }
      else {
        const {deleteBulkTags} = this;
        deleteBulkTags({projectUid, bulkTags, categoryId: currentCategory.id}).then(r => {
          closeSidePanel();
          this.selectedRows = [];
        });
      }
    },
    onBulk: function(action) {
      if (action == "edit") {
        this.bulkEditOpen = true;
      }
      if (action == "merge") {
        this.bulkMergeOpen = true;
      }
      if(action == "delete"){
        this.bulkDeleteOpen = true;
      }
    },
    closeSidePanel: function() {
      this.bulkEditOpen = false;
      this.bulkMergeOpen = false;
      // this.showMoreInformation = false;
      this.showEditTagSource = false;
      this.bulkDeleteOpen = false;
      this.showDeleteTagsWithNoArticlesConfirm = false;
      this.duplicated = false;
      this.selectedRows = [];
      this.$nextTick(() => {
        this.$refs.tagstable?.setSelectedRows?.(this.selectedRows);
      });
    },
    openDeletePanel: function(row){
      this.showDeleteTag = true;
      this.deleteTagObj = {...row};
    },
    closeDeletePanel: function(){
      this.showDeleteTag = false;
    },
    onBulkUpdate: function(field, value) {
      let rows = _.cloneDeep(this.selectedRows)
      let bulkTags = rows.map(tag => {
        tag[field] = value;
        return tag;
      });
      const projectUid = this.projectUid;
      this.updateBulkTagsByProject({ projectUid, bulkTags });
      this.closeSidePanel();
      this.selectedRows = [];
      this.duplicated = false;
    },
    onBulkSourceUpdate: function(field, value) {
      let rows = _.cloneDeep(this.selectedRows)
      let bulkTags = rows.map(tag => {
        tag[field] = value;
        return tag;
      });
      const projectUid = this.projectUid;

      this.updateBulkSourceByProject({ projectUid, bulkTags }).then(() => {
        this.closeSidePanel();
        this.selectedRows = [];
      })
    },
    onSortTable: async function({order, sort}) {
      this.pagination = {
        order: order,
        sort: sort,
        page: 1,
        perPage: this.pagination.perPage
      }
    },
    openSidePanel: function(row) {
      this.currentCategoryTagId = row.id
      this.showEditTagSource = true;
    },

    onSendSource(source) {
      const { projectUid } = this;
      this.updateSource({ projectUid, source }).then(r => {
        this.showEditTagSource = false;
      });
    },
    scroll: function() {
      window.onscroll = () => {
        if (this.$refs.tagstable) {
          const wHeight = window.innerHeight;
          const { top, bottom, height } = this.$refs.tagstable.$el.getBoundingClientRect();
          const margin = 100;

          if ((top * (-1) + wHeight >= height - margin) && !this.isBusy && !this.isTagsBusy) {
            this.getNextPage();
          }
        }
      } 
    },
    handlePasswordValid(val) {
      this.isPasswordValid = val;
    },
    onDateInputChanged(value) {
      this.filters.fromDate = value[0] || undefined;
      this.filters.toDate = value[1] || undefined;
      this.resetPagination();
      this.loadCategoryTagsOrSources();
      let { dateType, fromDate, toDate } = this.filters;
      dateType = (fromDate || toDate) ? 'tags_created_at' : undefined;
      this.$router.push({ query: { ...this.$route.query, dateType, fromDate, toDate } });
    }
  },
  data: function() {
    const projectUid = this.$route.params.project_uid;
    return {
      isReady: false,
      counter: 0,
      showDateByFilters: false,
      displayTableBySearch: false,
      projectUid,
      options: [
        { value: true, label: 'Approved' },
        { value: false, label: 'Not Approved' }
      ],
      selectedRows: [],
      duplicated: false,
      bulkEditOpen: false,
      pagination: {
        page: 1,
        perPage: 20,
        order: "tag_key",
        sort: "asc"
      },
      bulkMergeOpen: false,
      bulkDeleteOpen: false,
      showDeleteTagsWithNoArticlesConfirm: false,
      selectedCategoryId: null,
      selectedOrganizationCategoryId: null,
      selectedParentTagId: null,
      mergeId: '',
      currentCategoryTagId: null,
      deleteTagObj: {},
      showDeleteTag: false,
      showEditTagSource: false,
      mergeSelectedRow: '',
      submittedSearchParams: [],
      filters: {
         "search": [],
         fromDate: null,
         toDate: null
      },
      categoryTypes: { 
        search: [{ value: 'name', label: this.$i18n.t('tag.list.tag_name') }]
      },
      search: null,
      validatingPassword: false,
      isPasswordValid: false,
      weightOfCoverageName: 'weight of coverage',
      organizationsCategoryOptions: [],
      isChildCategoryLoading: false,
      updatingRowId: null
    }
  },
  mixins: [propsForMixin],
  watch: {
    usedTableSearch(newValue) {
      this.clearTags();
      this.selectedRows = [];
      this.duplicated = false;
    },
    isBusy: {
      handler(value){
        if (!this.isReady) {
          this.isReady = !value;
        }
      }
    },
    currentCategory() {
      this.counter++;
    },
    pagination: {
      handler(){
        this.loadCategoryTagsOrSources();
      },
      deep: true
    },
    search: {
      handler(){
        this.resetPagination();
        this.loadCategoryTagsOrSources();
      },
      deep: true
    },
    tags: {
      handler(val) {
        if(val?.length){
          this.isChildCategoryLoading = false;
        }
        const duplicatedTags = val.filter(tag => tag.duplicated_tag);
        if(duplicatedTags.length > 0) {
          this.selectedRows = duplicatedTags;
          this.duplicated = true;
          this.bulkMergeOpen = true;
          this.$nextTick(() => {
            this.$refs.tagstable?.setSelectedRows?.(this.selectedRows);
          });
        }
        if(val?.length && this.isUseOrgWithCategory && this.selectedOrganizationCategoryId && this.organizationCategoryId === val[0].cat_id){
          this.organizationsCategoryOptions = (val || []).map((c, i) => {
            c.value = c?.id;
            c.title = c?.name;
            c.order = c?.display_order || i+1;
            return c;
          });
          this.selectedParentTagId = this.organizationsCategoryOptions?.[0]?.id;
          this.isChildCategoryLoading = true;
          this.loadCategoryTagsOrSources().finally(() => {
            this.isChildCategoryLoading = false;
          });
        }
      }
    },
    selectedParentTagId: {
      handler(val) {
        if(val && !this.$route.query?.parent_tag_id) this.$router.push({ query: { ...this.$route.query, parent_tag_id: val } });
      }
    }
  },
};
</script>

<style lang="scss" scoped>

.selected-label{
  margin-top: 30px;
}

.table-outer {
  overflow: visible;
}

.div-categories-tag {
  display: flex;
  flex-direction: row;
  margin-bottom: 25px;
  margin-top: 10px;

  #categories, #child-categories {
    margin-top: -5px;
    margin-left: 30px;
  }
}

  @import "../../styles/components/coding-admin/_tags.scss";
  @import "../../styles/components/_datatable_bulk_actions.scss";

  :deep(.source-affiliation-select.multiselect) {
    font-size: 0;
    padding: 0;
    margin: 0;
    min-height: 0;
    height: auto;

    .multiselect__select {
      top: calc(50% - 14px);
      line-height: 0;
    }

    .multiselect__tags {
      padding: 0;
      margin: 0;
      min-height: 0;
      border-radius: 5px;
      padding: 20px;

      .multiselect__single,
      .multiselect__placeholder {
        font-size: 16px;
        line-height: 1.4;
      }
    }
  }

</style>